import { faInfo as fasInfo } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import compact from "lodash/compact";
import type { ReactNode } from "react";
import React from "react";

interface Props {
	className?: string;
	title?: ReactNode;
	icon?: ReactNode;
	bordered?: boolean;
	size?: "sm";
}

export class InfoBox extends React.PureComponent<Props> {
	public render(): ReactNode {
		const { children, className, icon = <FontAwesomeIcon icon={fasInfo} />, title, bordered, size } = this.props;

		const mainClassName = compact([
			"info-box",
			className,
			bordered && "info-box-bordered",
			size === "sm" && "info-box-sm",
		]).join(" ");

		return (
			<div className={mainClassName}>
				<div className="info-box-append">{icon && <span className="info-box-icon">{icon}</span>}</div>
				<div className="info-box-body">
					{title && <div className="info-box-title">{title}</div>}
					<div className="info-box-content">{children}</div>
				</div>
			</div>
		);
	}
}
